import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Popover, PopoverBody, Tooltip } from 'reactstrap';
import UserProfileImage, { getInitials } from '../components/userProfileImage';
import { getSizes, getUserName } from '../components/utils';
import TimeAgo from 'react-timeago';
import * as activityActions from '../actions/activity';
import classNames from 'classnames';
//import defaultAvatar from '../images/default-avatar.png';
import pencil from '../images/icons/pencil.svg';
import trash from '../images/icons/trash.svg';
import { eventView } from '../components/GoogleAnalytics';


class Comment extends Component {
    constructor(props) {
        super(props);
        const { comment } = this.props;
        this.state = {
            editId: null,
            commentText: comment ? comment.Comment : "",
            prevComment: comment ? comment.Comment : "",
        };
    }

    textChange = (e) => {
        if (e && e.target)
            this.setState({ commentText: e.target.value });
    }

    keyDown = (event) => {
        if (!event || (event.key !== 'Escape' && event.key !== 'Enter')) return;
        event.preventDefault();

        if (event.key === "Escape")
            this.cancelEdit();
        else if (event.key === "Enter")
            this.saveEdit();
    }

    cancelEdit = () => {
        this.setState({ commentText: this.state.prevComment, editId: null });
    }

    saveEdit = () => {
        if (this.state.commentText && this.state.commentText !== "") {
            this.props.activityActions.updateComment({ Id: this.props.comment.Id, Comment: this.state.commentText }).then(() => {
                this.props.activityActions.fetchSingleActivity(this.props.comment.ActivityId);
            });
            this.setState({ editId: null, prevComment: this.state.commentText });

            // Register comment action with GA
            eventView('User','UpdateComment');
        }
    }

    onEditComment = () => {
        if(this.props.comment && this.props.comment.Id){
            this.setState({editId: this.props.comment.Id},() => {
                if(this.editCommentInputRef) this.editCommentInputRef.focus();
            });            
        }
    }

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(this.props.comment) !== JSON.stringify(nextProps.comment)) {
            this.setState({ editId: null, commentText: nextProps.comment.Comment, prevComment: nextProps.comment.Comment });
        }
    }

    render() {
        const { comment, myProfile, userPhotoList = [] } = this.props;
        const { isMobile } = getSizes();
        var curUsr = [...userPhotoList, { id: comment.CommentAddedById, 
                        initials: getInitials({ FirstName: comment.CommentAddedByName }) }]
                    .find(u => u.id === comment.CommentAddedById);

        return (
            <div key={comment.Id} className="activity_comment">
                 <UserProfileImage
                    id={curUsr.id}
                    initials={curUsr.initials} 
                    photo={curUsr.photo} />
                <div className="comment_container">
                    <div className="comment_header">
                        <span className="comment_actionby">{getUserName(comment.CommentAddedByName, comment.CommentAddedById, myProfile)}</span>
                        <span className="comment_separator">&middot;</span>
                        <span className="comment_date"><TimeAgo title={null} date={comment.CommentDate} /></span>
                    </div>
                    {this.state.editId && !isMobile &&
                        <div className="comment_content dyna-form">
                            <input type="text" placeholder="Update comment" 
                                ref={(ref) => this.editCommentInputRef = ref}
                                value={this.state.commentText} 
                                onChange={this.textChange} 
                                onKeyDown={this.keyDown} />
                            <div className="note_text">Press Esc to<div onClick={this.cancelEdit} className="blue_text">cancel</div></div>
                        </div>
                    }
                    {this.state.editId && isMobile &&
                        <div className="comment_content dyna-form">
                            <textarea ref={(ref) => this.editCommentInputRef = ref} 
                                onChange={this.textChange} 
                                value={this.state.commentText} />
                                <div className="txt-algn-rt">
                                    <button className="dyna-btn dyna-btn_mobile mg-rt-8" style={{width:'57px'}} 
                                        onClick={this.saveEdit}>Update</button>
                                    <button className="dyna-btn dyna-btn_mobile" style={{width:'57px'}} 
                                        onClick={this.cancelEdit}>Cancel</button>
                                </div>
                        </div>
                    }
                    {!this.state.editId &&                    
                        <div className="comment_content">
                            <span>{this.state.commentText}</span>
                            {(myProfile && comment.CommentAddedById === myProfile.Id) &&
                                <CommentAction comment={comment}
                                    activities={this.props.activities}
                                    isModal={this.props.isModal}
                                    isMobile={this.props.isMobile}
                                    onEditComment={this.onEditComment} 
                                    onDeleteComment={this.props.onDeleteComment} 
                                    activityActions={this.props.activityActions}
                                    isCommentDeleting={this.props.isCommentDeleting}
                                    isCommentDeleted={this.props.isCommentDeleted} />
                            }                        
                        </div>
                    }
                </div>
            </div>
        )
    }
}

class CommentAction extends Component {
    constructor(props) {
        super(props);

        this.state = {
            popoverOpen: false,
            tooltipOpen: false
        };
        this.deleteComment = this.deleteComment.bind(this);
    }

    toggle = (key) => {
        // fix for tooltip remaining after closing the popover
        if (key === 'popoverOpen' && this.state.popoverOpen && this.state.tooltipOpen)
            this.setState({ tooltipOpen: false })

        this.setState({ [key]: !this.state[key] })
    }

    deleteComment = () => {
        if(this.props.comment && this.props.comment.Id){
            this.props.activityActions.deleteComment(this.props.comment.Id);
            // deleted comments don't get removed from API response so do it manually
            var activity = this.props.activities[this.props.comment.ActivityId];
            var newActivity = {...activity, Comments: activity.Comments.filter(c => c.Id !== this.props.comment.Id)}
            this.props.activityActions.removeComment(newActivity);

            window.sessionStorage.setItem("DeleteCommentId", this.props.comment.Id);
            
            // Register comment action with GA
            eventView('User','DeleteComment');
        }
    }

    editComment = () => {
        if(this.props.onEditComment){
            this.toggle('popoverOpen');
            this.props.onEditComment();
        } 
    }

    componentWillReceiveProps(nextProps) {
        if(!this.props.isCommentDeleted && nextProps.isCommentDeleted){
            if(window.sessionStorage.getItem("DeleteCommentId") === this.props.comment.Id){
                window.sessionStorage.removeItem("DeleteCommentId");
                this.toggle('popoverOpen');
                this.props.activityActions.fetchSingleActivity(this.props.comment.ActivityId);
                if(this.props.onDeleteComment) this.props.onDeleteComment();            
            }
		}
	}

    render() {
        const {comment, isModal, isMobile} = this.props;
        var targetId = classNames(`commentPopover_${comment.Id}`, {'modal': isModal, 'mobile': isMobile}).replace(/[ ]/g, '_');

        return (
            <span>
                <button className={classNames('comment_actions_container', { 'mobile': isMobile })} id={targetId}
                    style={{ display: "inline-block", visibility: this.state.popoverOpen ? 'visible' : null }}>
                    <span className="pointer-events-none">
                        <span className="comment_actions"><img src={pencil} alt="Edit or Delete" /></span>
                        {/* scrollParent was added because the overflow-y property of parent causes weird flicker in comments modal when hovering edit icon */}
                        {!isMobile &&
                            <Tooltip boundariesElement={isModal ? ['scrollParent'] : null} delay={{ show: 0, hide: 0 }} isOpen={this.state.tooltipOpen && !this.state.popoverOpen} toggle={() => this.toggle('tooltipOpen')} placement="top"
                                target={targetId}>
                                Edit or Delete
                            </Tooltip>
                        }
                    </span>
                </button>
                {/* scrollParent was added because the overflow-y property of parent causes weird flicker in comments modal when hovering edit icon */}
                <Popover 
                    target={targetId} trigger="legacy"
                    isOpen={this.state.popoverOpen} fade={false} 
                    boundariesElement={isModal ? ['scrollParent']: null} placement="top" 
                    toggle={() => this.toggle('popoverOpen')}>
                    <PopoverBody style={{paddingLeft: 0, paddingRight: 0}}>
                        {this.props.isCommentDeleting &&
                            <div>                        
                                <div className="comment_action_btn"><img src={pencil} alt="Edit" /><span>Edit</span></div>
                                <div className="comment_action_btn"><img src={trash} alt="Delete" /><span>Deleting...</span></div>
                            </div>
                        }
                        {!this.props.isCommentDeleting &&
                        <div>                        
                            <div className="comment_action_btn" onClick={this.editComment}><img src={pencil} alt="Edit" /><span>Edit</span></div>
                            <div className="comment_action_btn" onClick={this.deleteComment}><img src={trash} alt="Delete" /><span>Delete</span></div>
                        </div>
                        }
                    </PopoverBody>
                </Popover>
            </span>
        )
    }
}

const mapStateToProps = (state, props) => ({
    isCommentDeleting: {...initialState, ...state.activity}.feed.isCommentDeleting,
    isCommentDeleted: {...initialState, ...state.activity}.feed.isCommentDeleted,
    activities: state.entities.Activities || {},
});
const mapDispatchToProps = dispatch => ({
    activityActions: bindActionCreators(activityActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Comment);

const initialState = {
    feed: {
       isCommentDeleting: false,
       isCommentDeleted: false
    }
}